// src/stores/counter-store.ts
import { Role } from '@common/application/enums/Role';
import { ICurrency } from '@common/types/currency';
import { Nullable } from '@common/types/utils';
import { createStore } from 'zustand/vanilla';

export type ConfigState = {
  currency: ICurrency;
  company: Nullable<number>;
  role: Nullable<Role>;
  impersonatedRole: Nullable<Role>;
};

export type ConfigActions = {
  setCurrency: (curr: ICurrency) => void;
  setCompany: (comp: number) => void;
  setRole: (role: Role) => void;
  setImpersonatedRole: (role: Role) => void;
};

export type ConfigStore = ConfigActions & ConfigState;

export const defaultInitState: ConfigState = {
  currency: {
    iso4217: 'GBP',
    iconName: 'sterling-sign',
    name: 'Pound sterling',
  },
  company: null,
  role: null,
  impersonatedRole: null,
};

export const createConfigStore = (initState: ConfigState = defaultInitState) => {
  return createStore<ConfigStore>()((set) => ({
    ...initState,
    setCurrency: (currency: ICurrency) => set((state) => ({ currency })),
    setCompany: (company: number) => set((state) => ({ company })),
    setRole: (role: Role) => set((state) => ({ role })),
    setImpersonatedRole: (impersonatedRole: Role) => set((state) => ({ impersonatedRole })),
  }));
};
